import * as React from "react";
import { Form , Dropdown , Button } from 'semantic-ui-react'
import { db } from "../../firebase";

interface InterfaceProps {
  error?: any;
  history?: any;
  categories?: any[];
  tag?:any;
  onAssigned:any
}

interface InterfaceState {
  error?: any;
  relatedCategories?: any[];
}

export class TagToCategoryAssignForm extends React.Component<
  InterfaceProps,
  InterfaceState
> {
  private static INITIAL_STATE = {
    error: null,
    relatedCategories: []
  };

  private static propKey(propertyName: string, value: string): object {
    return { [propertyName]: value };
  }

  constructor(props: any) {
    super(props);
    this.state = { ...TagToCategoryAssignForm.INITIAL_STATE };
  }

  public onSubmit = (event: any) => {
    const { relatedCategories }: any = this.state;
    const { tag, categories, onAssigned }: any = this.props;

    db.doAffectTagToCategory(tag , categories , relatedCategories)
        .then(() => { 
          this.setState(() => ({ ...TagToCategoryAssignForm.INITIAL_STATE }));
          onAssigned()
        })
        .catch(error => {
          this.setState(TagToCategoryAssignForm.propKey("error", error));
        });
    
    
    
        /*db.doUpdateTag(tag.id, tag.text, relatedCategories)
        .then(() => {
                relatedCategories.map((category) => {
                const relatedTags = [...categories[category.id].tags, {id:tag.id, text:tag.text }]
                db.doUpdateCategory(category.id, category.name, relatedTags)
                .then(() => {
                    this.setState(() => ({ ...TagToCategoryAssignForm.INITIAL_STATE }));
                    onAssigned()
                })
                .catch(error => {
                    this.setState(TagToCategoryAssignForm.propKey("error", error));
                }); 
            })
        })
        .catch(error => {
            this.setState(TagToCategoryAssignForm.propKey("error", error));
    }); */
    event.preventDefault();
  };


public handlechange = (value: any) =>{
  const { categories }: any = this.props;
  const categoriesList = value.map((item) => {
    return {id: categories[item].id , name: categories[item].name }
  })
  this.setState({
    relatedCategories: categoriesList
  });
}

  public render() {
    const { relatedCategories, error }: any = this.state;
    const { categories }: any = this.props;
    const categoriesOptions = Object.keys(categories).map(key => ({ key, value: key, text: categories[key].name }));
    const isInvalid = relatedCategories.length === 0;

    return (
        <Form onSubmit={event => this.onSubmit(event)}>
          <Form.Field>
            <label>Related Categories</label>
            <Dropdown 
                name='relatedCategories'
                placeholder='Categories' 
                onChange={(e , { value }) => this.handlechange(value)}
                fluid multiple search selection 
                options={categoriesOptions} />
          </Form.Field>
          <Button type='submit' disabled={isInvalid} positive>Save</Button>
          {error && <p>{error.message}</p>}
        </Form>
    );
  }

}


// WEBPACK FOOTER //
// ./src/pills/tags/assignTagToCategoryForm.tsx